import { Button} from "@material-ui/core"
import React from "react"
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";


function NavbarButton(props){
    const {icon, label, path, onClickfn} = props;
    const location = useLocation();
    const isSelected = location.pathname === path;

    return(
        <Button
            onClick={()=>onClickfn(path)}
            variant="text"
            disableRipple
            disableFocusRipple
            startIcon={<img className={isSelected? "navbar-icon-selected" : "navbar-icon" } src={icon}/>}
            color={isSelected? "primary" : "secondary"}
        >
        {label}
        </Button>
    )
}

export {NavbarButton}